import { makeRequest } from 'src/helpers/request'

export const ConnectedAppsService = {
  approveAuthorize: (state: string): Promise<{ redirectUrl: string }> => {
    return makeRequest(`${import.meta.env.VITE_API_URL}/connected-apps/authorize/approve`, 'post', { state })
  },
}
